import { createContext, useContext } from 'react';
import type { AssessmentPortalConfig } from '../types/config';

export interface AssessmentPortalContextValue<TFlowState = Record<string, any>> {
  config: AssessmentPortalConfig<TFlowState>;
  flowState: TFlowState;
  updateFlowState: (key: string, value: any) => void;
  goToStep: (stepKey: string) => void;
  currentStepIndex: number;
}

const AssessmentPortalContext = createContext<AssessmentPortalContextValue<any> | null>(null);

export const useAssessmentPortalConfig = (): AssessmentPortalConfig => {
  const ctx = useContext(AssessmentPortalContext);
  if (!ctx) {
    throw new Error(
      'useAssessmentPortalConfig must be used within an AssessmentPortalProvider',
    );
  }
  return ctx.config;
};

export const useAssessmentPortalState = <
  T = Record<string, any>,
>(): AssessmentPortalContextValue<T> => {
  const ctx = useContext(AssessmentPortalContext);
  if (!ctx) {
    throw new Error(
      'useAssessmentPortalState must be used within an AssessmentPortalProvider',
    );
  }
  return ctx as AssessmentPortalContextValue<T>;
};

export default AssessmentPortalContext;
